export default __webpack_public_path__ + "static/media/main.e9b45037.png";